import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import Loader from 'shared/common/loader';
import dashboardService from 'services/dashboard.service';

export const resetKycCache = () => {
  kycPromise = null;
};

let kycPromise: Promise<{ completed: boolean; error?: string }> | null = null;

const getKycFraudStatus = () => {
  if (!kycPromise) {
    kycPromise = dashboardService
      .isKYCFraudComplete()
      .then((response: any) => (
        {
        completed: !!response.data?.kyc_completed,
        error: response.data?.kyc_error,
      }))
      .catch(() => {  
        kycPromise = null; 
        return { completed: false, error: 'Something went wrong' };
      });
  }
  return kycPromise;
};

const FraudprivateRoute = ({ component: Component, ...rest }) => {

  const [loading, setLoading] = useState(true);
  const [kycError, setKycError] = useState('');
  const [isKycFRequired, setIsKycFRequired] = useState(false);

  useEffect(() => {
    getKycFraudStatus().then(({ completed, error }) => {
      if (!completed) {
        setIsKycFRequired(true);
        setKycError(error);
      }
      setLoading(false);
    });
  }, []);

  return (
    <>
      {loading && <Loader />}
      <Route
        {...rest}
        render={(props) =>
          !isKycFRequired ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: '/dashboard',
                state: { isKycRequired: true, kycError },
              }}
            />
          )
        }
      />
    </>
  );
};

export default FraudprivateRoute;
